/**
 * @desc 分页查询竞拍
 */
import {
  PageAuctionOperationPageItem,
  AuctionOperationPageParam
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAuctionPageParameter = AuctionOperationPageParam

const method = 'GET'
const url = '/trade/operation/auction/page'

export const queryAuctionPageApi = (
  params?: QueryAuctionPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageAuctionOperationPageItem>({
    method,
    url,
    params,
    ...config
  })
}

queryAuctionPageApi.method = method
queryAuctionPageApi.url = url
